<template>
  <div class="flugstrecken-container">
    <!-- Container für die IST-Seite -->
    <div v-if="$slots['ist-content']" class="compare-container">
      <div class="d-flex">
        <div style="font-weight: 600; font-size: 14px; color: #464e5f">{{ istTitle }}</div>
        <div class="ml-auto" style="display: flex; gap: 8px">
          <span v-if="statusPruefung === 'AllGood'">
            <Plane :size="16" class="text-success" />
          </span>
          <span v-else-if="statusPruefung === 'SomethingWrong'">
            <Plane :size="16" class="text-warning" />
          </span>
          <span v-else-if="statusPruefung === 'NoSegment'">
            <Plane :size="16" class="text-danger" />
          </span>
          <Tickets v-if="statusTickets === 'AllGood'" :size="16" class="text-success" />
          <Tickets v-else-if="statusTickets === 'CheckRequired'" :size="16" class="text-warning" />
          <Tickets v-else :size="16" class="text-danger" />
        </div>
      </div>

      <!-- Slot für Ist-Inhalt -->
      <slot name="ist-content"></slot>
    </div>

    <!-- Container für die Soll-Seite -->
    <div
      v-if="$slots['soll-content']"
      class="compare-container d-flex"
      style="background-color: #f6f6f9; flex-direction: column"
    >
      <div style="font-weight: 600; font-size: 14px; color: #464e5f">{{ sollTitle }}</div>

      <!-- Slot für Soll-Inhalt -->
      <slot name="soll-content"></slot>
    </div>
  </div>
</template>

<script>
import { Plane, Tickets } from 'lucide-vue';

export default {
  components: { Plane, Tickets },
  props: {
    istTitle: { type: String },
    sollTitle: { type: String },
    statusPruefung: { type: String, required: true }, // 'AllGood', 'SomethingWrong', 'NoSegment' // nur für den IST-Zustand notwendig
    statusTickets: { type: String, required: true }, // 'AllGood', 'CheckRequired', 'Critical' // nur für den IST-Zustand notwendig
  },
};
</script>

<style scoped>
.flugstrecken-container {
  display: flex;
  flex-direction: row;
  /* padding: 4px; */
  justify-content: center;
  gap: 2px;
}

.compare-container {
  padding: 16px 16px 24px 16px;
  flex-grow: 1;
  width: 430px;
  background-color: var(--surface);
  border-radius: 8px;
  box-shadow: 0px 0px 4px 0px #00000040;
  font-family: 'Poppins', sans-serif;
  angle: 0 deg;
  opacity: 1;
}
</style>
